export const TABS = {
    SCAN: { value: "SCAN", text: "기본입력" },
    FORM: { value: "FORM", text: "필드입력" },
};
